import * as types from './mutation-types'

export const loadPropertySpecifications = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/property/characteristic/collection').then((response) => {
            commit(types.LOAD_PROPERTY_SPECIFICATIONS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storePropertySpecification = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/property/characteristic', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProjectCategory = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/property/characteristic/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProjectCategory = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/property/characteristic/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}




